<header class="header">
  <app-header></app-header>
</header>
<main class="page">
  <router-outlet></router-outlet>
</main>
<footer class="header">
  <app-footer></app-footer>
</footer>
